import { render, staticRenderFns } from "./InputTextMask.vue?vue&type=template&id=18f1d217&scoped=true"
import script from "./InputTextMask.vue?vue&type=script&lang=js"
export * from "./InputTextMask.vue?vue&type=script&lang=js"
import style0 from "./InputTextMask.vue?vue&type=style&index=0&id=18f1d217&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f1d217",
  null
  
)

export default component.exports